import React from "react";
import PropTypes from "prop-types";

function FinancialProfile({
  className,
  style,
  fill,
  barFill,
  opacity,
  defaultWidth,
  defaultHeight
}) {
  return (
    <svg
      viewBox="0 0 128 127"
      width={style && style.width ? style.width : defaultWidth}
      height={style && style.width ? style.height : defaultHeight}
      style={style}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g fill-rule="nonzero" fill="none">
        <g fill={fill}>
          <path d="M10.534 0H2.873c-6.716 0-.639 22.917 17.875 22.917h7.661C34.921 22.917 29.124 0 10.534 0zm10.214 17.825c-7.48.004-13.87-5.378-15.117-12.732h4.903c7.48-.005 13.87 5.377 15.117 12.732h-4.903z" />
          <path
            d="M25.651 17.825h-4.903c-7.48.004-13.87-5.378-15.117-12.732h4.903c7.48-.005 13.87 5.377 15.117 12.732z"
            opacity={opacity}
          />
          <path d="M53.945 7.64c-8.3 0-16.65-1.045-23.62 7.638a19.979 19.979 0 00-4.47 12.732 2.55 2.55 0 002.554 2.546h7.66c18.438 0 24.669-22.917 17.876-22.917zM36.07 25.463h-4.903c1.247-7.355 7.637-12.737 15.117-12.732h4.903c-1.246 7.355-7.637 12.737-15.117 12.732z" />
          <path
            d="M51.187 12.732c-1.246 7.355-7.637 12.737-15.117 12.732h-4.903c1.247-7.355 7.637-12.737 15.117-12.732h4.903z"
            opacity={opacity}
          />
          <path d="M25.855 81.484v-63.66a2.55 2.55 0 012.554-2.546 2.55 2.55 0 012.554 2.547v63.659a2.55 2.55 0 01-2.554 2.546 2.55 2.55 0 01-2.554-2.546z" />
          <path d="M42.862 92.026l-12.64-12.732a2.557 2.557 0 00-3.626 0l-12.64 12.732c-7.972 7.957-7.967 20.851.01 28.803 7.978 7.952 20.908 7.952 28.886 0 7.977-7.952 7.982-20.846.01-28.803zm-3.626 25.107a15.351 15.351 0 01-14.85 4.044 15.3 15.3 0 01-10.878-10.86 15.249 15.249 0 014.074-14.803L28.409 84.82l10.827 10.797c5.924 5.956 5.924 15.56 0 21.517z" />
          <path
            d="M39.236 95.616L28.41 84.819 17.582 95.616a15.247 15.247 0 00-3.33 16.652 15.322 15.322 0 0014.157 9.436 15.322 15.322 0 0014.157-9.436 15.247 15.247 0 00-3.33-16.652zm-12.104 6.239h2.554c3.526-.352 6.67 2.213 7.022 5.729.353 3.516-2.22 6.65-5.745 7.002a2.55 2.55 0 01-2.554 2.547 2.55 2.55 0 01-2.554-2.547h-2.553a2.55 2.55 0 01-2.554-2.546 2.55 2.55 0 012.554-2.546h6.384c.705 0 1.277-.57 1.277-1.273 0-.704-.572-1.274-1.277-1.274h-2.554c-3.526.352-6.67-2.213-7.022-5.729-.353-3.516 2.22-6.65 5.745-7.002a2.55 2.55 0 012.554-2.547 2.55 2.55 0 012.554 2.547h2.553a2.55 2.55 0 012.554 2.546 2.55 2.55 0 01-2.554 2.546h-6.384c-.705 0-1.277.57-1.277 1.273 0 .704.572 1.274 1.277 1.274z"
            opacity={opacity}
          />
          <path d="M36.07 76.391a2.554 2.554 0 01-2.373-1.57 2.541 2.541 0 01.56-2.784L64.9 41.48a2.557 2.557 0 013.626 0L82.035 54.9l33.886-36.26a2.559 2.559 0 013.486-.005 2.541 2.541 0 01.243 3.467c-38.305 40.92-36.006 39.01-37.615 39.01-1.609 0-.92.179-15.322-14.233C35.508 77.995 37.576 76.39 36.07 76.39z" />
          <path d="M115.232 38.195V22.917H99.91a2.55 2.55 0 01-2.553-2.546 2.55 2.55 0 012.553-2.546h17.876a2.55 2.55 0 012.553 2.546v17.824a2.55 2.55 0 01-2.553 2.547 2.55 2.55 0 01-2.554-2.547zM125.446 119.68H51.392a2.55 2.55 0 01-2.554-2.547 2.55 2.55 0 012.554-2.547h74.054a2.55 2.55 0 012.554 2.547 2.55 2.55 0 01-2.554 2.546z" />
        </g>
        <path
          d="M100 114.457v-42.85c0-1.405 1.12-2.543 2.5-2.543s2.5 1.138 2.5 2.543v42.85c0 1.404-1.12 2.543-2.5 2.543s-2.5-1.139-2.5-2.543zM100 61.5v-5a2.5 2.5 0 015 0v5a2.5 2.5 0 01-5 0zM80 117.5v-25a2.5 2.5 0 015 0v25a2.5 2.5 0 11-5 0zM80 81.5v-5a2.5 2.5 0 015 0v5a2.5 2.5 0 01-5 0zM59 117.429V104.57c0-1.42 1.12-2.571 2.5-2.571s2.5 1.151 2.5 2.571v12.858c0 1.42-1.12 2.571-2.5 2.571s-2.5-1.151-2.5-2.571zM59 94.5v-5a2.5 2.5 0 015 0v5a2.5 2.5 0 01-5 0z"
          opacity={opacity}
          fill={barFill}
        />
      </g>
    </svg>
  );
}

FinancialProfile.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  fill: PropTypes.string,
  barFill: PropTypes.string,
  opacity: PropTypes.number
};

FinancialProfile.defaultProps = {
  className: undefined,
  defaultHeight: 127,
  defaultWidth: 128,
  fill: "#99B5B7",
  barFill: "#26E3BA",
  opacity: 0.5
};

export default FinancialProfile;
